// * Airtable attachment URLs expire a few hours after they are fetched, so
//   attachments are copied to R2 at build time (see attachment-sync.js) and
//   served from a permanent URL keyed by the attachment id. [1]
// * Without a base URL (e.g. local development without R2 credentials), fall
//   back to the expiring Airtable URLs. [2]
// * The base URL is read on each call because gatsby-config.js requires this
//   module before it loads the .env file. [3]

// `size` is 'original' or an Airtable thumbnail size such as 'large'.
const attachmentKey = (id, size) => `airtable/${id}/${size}`

const attachmentUrl = (attachment, size = 'original') => {
  const baseUrl = process.env.GATSBY_ATTACHMENT_BASE_URL // [3]
  if (baseUrl) return `${baseUrl}/${attachmentKey(attachment.id, size)}` // [1]
  const thumbnail = attachment.thumbnails && attachment.thumbnails[size]
  return thumbnail ? thumbnail.url : attachment.url // [2]
}

module.exports = { attachmentKey, attachmentUrl }
